var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPeople(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "20.75px",
    height: "18.75px",
    viewBox: "1.625 2.625 20.75 18.75",
    enableBackground: "new 1.625 2.625 20.75 18.75",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    d: "M14.75,15c0.967,0,1.75,0.783,1.75,1.75l-0.001,0.962c0.116,2.189-1.511,3.297-4.432,3.297 c-2.909,0-4.567-1.09-4.567-3.259v-1C7.5,15.783,8.284,15,9.25,15H14.75z M3.75,10h4.376C8.044,10.32,8,10.655,8,11 c0,1.116,0.457,2.125,1.193,2.85l0.162,0.151L9.25,14c-0.301,0-0.591,0.049-0.863,0.139c-0.865,0.285-1.54,0.988-1.786,1.869 l-0.034,0.001C3.658,16.009,2,14.919,2,12.75v-1C2,10.784,2.784,10,3.75,10z M20.25,10c0.967,0,1.75,0.784,1.75,1.75l-0.001,0.962 c0.116,2.189-1.511,3.297-4.433,3.297l-0.168-0.001c-0.238-0.854-0.88-1.541-1.705-1.842c-0.236-0.086-0.486-0.141-0.746-0.159 L14.75,14l-0.105,0.001C15.476,13.268,16,12.195,16,11c0-0.345-0.044-0.68-0.126-1H20.25z M12,8c1.656,0,3,1.343,3,3 c0,1.656-1.344,3-3,3c-1.657,0-3-1.344-3-3C9,9.343,10.343,8,12,8z M6.5,3c1.657,0,3,1.343,3,3s-1.343,3-3,3s-3-1.343-3-3 S4.843,3,6.5,3z M17.5,3c1.656,0,3,1.343,3,3s-1.344,3-3,3s-3-1.343-3-3S15.844,3,17.5,3z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPeople);
export default __webpack_public_path__ + "static/media/iconPeople.a7941886b29a78835d44e34b69d0a563.svg";
export { ForwardRef as ReactComponent };